<template>
  <div class="d-flex in-component">
    <v-col class="pt-0">
      <ValidationProvider
        v-slot="{ errors }"
        :name="label"
        :rules="disableGroup ? rules : null">
        <v-combobox
          :value="value"
          class="combobox-field"
          :items="items"
          hide-no-data
          hide-selected
          multiple
          small-chips
          deletable-chips
          :error-messages="errors[0]"
          :disabled="!disableGroup"
          solo
          @input="(val) => $emit('input', val)" />
      </ValidationProvider>
    </v-col>
  </div>
</template>

<script>
import SchemaController from '@/utils/schemaController'

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    rules: {
      type: String,
      default: ''
    },
    disableGroup: {
      type: Boolean,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    optionFunc: {
      type: String,
      default: 'none'
    }
  },
  data () {
    return {
      items: []
    }
  },
  async mounted () {
    this.items = this.optionFunc === 'none' ? this.options : await SchemaController[this.optionFunc]()
  }
}
</script>

<style>
.combobox-field {
  width: 362px;
  margin-top: -10px;
}

.combobox-field .v-input__append-inner {
  display: none;
}
</style>
